// extracted by mini-css-extract-plugin
export default {"text_field":"TextFIeld_text_field__J7g8m","label":"TextFIeld_label__KFVz9","input":"TextFIeld_input__FUZhs","error":"TextFIeld_error__fi+RH"};